/* istanbul ignore file */
import React, { createContext, useContext, ReactNode, useState, useCallback } from 'react';

interface RapportContextType {
  logoUrl: string | null;
  logoPosition: string;
  setLogo: (url: string | null, position?: string) => void;
  footerText: string | null;
  setFooterText: (text: string | null) => void;
  hasFrontPage: boolean;
  setHasFrontPage: (hasFrontPage: boolean) => void;
  hasBijlagen: boolean;
  setHasBijlagen: (hasBijlagen: boolean) => void;
}

const defaultContext: RapportContextType = {
  logoUrl: null,
  logoPosition: 'top-right',
  setLogo: () => { /* default empty implementation */ },
  footerText: null,
  setFooterText: () => { /* default empty implementation */ },
  hasFrontPage: false,
  setHasFrontPage: () => { /* default empty implementation */ },
  hasBijlagen: false,
  setHasBijlagen: () => { /* default empty implementation */ }
};

export const RapportContext = createContext<RapportContextType>(defaultContext);

export const useRapportContext = (): RapportContextType => useContext(RapportContext);

interface LogoProviderProps {
  children: ReactNode;
  defaultLogoUrl?: string | null;
  defaultPosition?: string; 
  defaultFooterText?: string | null;
  defaultHasFrontPage?: boolean;
  defaultHasBijlagen?: boolean;
}

export const RapportContextProvider: React.FC<LogoProviderProps> = ({
  children,
  defaultLogoUrl = null,
  defaultPosition = 'top-right',
  defaultFooterText = null,
  defaultHasFrontPage = false,
  defaultHasBijlagen = false
}) => {
  const [logoUrl, setLogoUrl] = useState<string | null>(defaultLogoUrl);
  const [logoPosition, setLogoPosition] = useState<string>(defaultPosition);
  const [footerText, setFooterText] = useState<string | null>(defaultFooterText);
  const [hasFrontPage, setHasFrontPage] = useState<boolean>(defaultHasFrontPage);
  const [hasBijlagen, setHasBijlagen] = useState<boolean>(defaultHasBijlagen);
  const setLogo = useCallback((url: string | null, position = 'top-right'): void => {
    setLogoUrl(url);
    setLogoPosition(position);
  }, []);

  return (
    <RapportContext.Provider value={{ logoUrl, logoPosition, setLogo, footerText, setFooterText, hasFrontPage, setHasFrontPage, hasBijlagen, setHasBijlagen }}>
      {children}
    </RapportContext.Provider>
  );
}; 